// socket.js
import { io } from 'socket.io-client';
import { API_URL } from '../constants/api';

const socket = io(API_URL, {
  transports: ['polling', 'websocket'], // IMPORTANT
  secure: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
});

export default socket;
